import Vue from 'vue'
import VueRouter from 'vue-router'
// import loadFile from '../utils/index.js'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const Link = () => import('../views/Link')
const Service = () => import('../views/Service')
const Plan = () => import('../views/Plan')
const Case = () => import('../views/Case')
const Tech = () => import('../views/Tech')
const Legal = () => import('../views/Legal')
const Theory = () => import('../views/Theory')
const Case1 = () => import('../views/Case1')
const Case2 = () => import('../views/Case2')
const Case3 = () => import('../views/Case3')



const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '/',
    component: HomePage
  }, {
    path: '/service',
    component: Service
  }, {
    path: '/plan',
    component: Plan
  }, {
    path: '/case',
    component: Case
  }, {
    path: '/link',
    component: Link
  }, {
    path: '/tech',
    component: Tech
  }, {
    path: '/legal',
    component: Legal
  },
  , {
    path: '/theory',
    component: Theory
  }, {
    path: '/case1',
    component: Case1
  }, {
    path: '/case2',
    component: Case2
  }, {
    path: '/case3',
    component: Case3
  }
  ]
});

// router.beforeEach((to, from, next) => {
// 	  if(to.path.indexOf('MP_verify_DzTeloZr4A48xL9s')>-1){
// 	   let url= loadFile('./MP_verify_DzTeloZr4A48xL9s.txt')
// 	   // let url = 'DzTeloZr4A48xL9s'
// 	   console.log('111111111111111111111'+url)
// 	  }else{
// 	   next()
// 	  }
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js